import React from 'react'

import TotpGuard from '@/app/component/guard/totp'
import Layout from '@/app/component/layout/page'
import { PAGE } from '@/app/definitions'
import { AuthGuard, AuthHeader } from '@/app/module/auth'
import Content, { ContentTab } from '@/app/module/content'
import Notifications from '@/app/module/notifications'
import { MatchProps } from '@/app/types'

type Props = {
  match: MatchProps & {
    params: {
      contentType?: string
    }
  }
}

export default function ContentPage({ match }: Props) {
  const { contentType } = match.params

  const type = React.useMemo(() => {
    if (!contentType || !Object.values(ContentTab).includes(contentType as ContentTab)) {
      return ContentTab.WaTemplates
    }
    return contentType as ContentTab
  }, [contentType])

  const title = React.useMemo(() => {
    switch (type) {
      case ContentTab.Quotas:
        return 'Content - Quotas - engageSPARK'
      case ContentTab.WaTemplates:
        return 'Content - WhatsApp Templates - engageSPARK'
      default:
        return 'Content - engageSPARK'
    }
  }, [type])

  return (
    <AuthGuard url={match.url} path={match.path}>
      <Layout title={title}>
        <AuthHeader currentPage={PAGE.CONTENT.INDEX} />
        <TotpGuard>
          <Content contentType={type} />
        </TotpGuard>
        <Notifications />
      </Layout>
    </AuthGuard>
  )
}
